/* eslint-disable react/jsx-no-comment-textnodes */
/* eslint-disable jsx-a11y/iframe-has-title */

import React from 'react'
import {MapContainer, TileLayer, Marker, Popup} from 'react-leaflet'
import {locals} from '../utils/map'




function Footer() {
    const {ceppo} = locals;
    return (
        <div style={{overflow:"hidden"}}>
        <div className="divider"/>
        <footer className="footer">
            <div className="footer-container grid-container">
                <div>
                    <h5 style={{fontSize:"larger"}}>Informazioni</h5>
                    <p style={{color:"white", fontSize:"small"}}>Via Giovanni Villano, 21</p>
                    <p style={{color:"white", fontSize:"small"}}>63074 San Benedetto del Tronto (AP)</p>
                    <p style={{color:"white", fontSize:"small"}}>Tel. 0735/673452</p>
                    <p style={{color:"white", fontSize:"small"}}>ceppotrekking@gmail.com</p>

                </div>
                <div>
                    <MapContainer center={ceppo} zoom={13} scrollWheelZoom={true} className="gmaps-embed">
                        <TileLayer 
                            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors | <a href="/mappa">vedi mappa completa</a>'
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"/>
                        <Marker position={ceppo}>
                            <Popup>
                                Ceppo!
                            </Popup>
                        </Marker>
                    </MapContainer>
                </div>
            </div>
            <hr style={{position:"relative", right: "20px", width:"200%"}}/>
            <div className="footer-container">
                <h4>
                    all &copy; reserved to 
                    <span className="logo-color"> Ceppo Trekking</span>
                </h4>
            </div>
        </footer>
        </div>
    )
}

export default Footer
